





















































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { ProductDetailsRequests } from "@/helpers";
import { UtilitiesFunctions } from "@/helpers";

@Component
export default class ProductDetail extends Vue {
  @Prop({ default: "" }) private id!: string;

  productDetails: any = null;
  detailsLoading = true;

  created() {
    this.getProductDetails(this.id);
  }

  closeDialog() {
    this.$store.dispatch("app/closeDialog");
  }

  getProductDetails(id: string) {
    this.detailsLoading = true;
    ProductDetailsRequests.fetch(id)
      .then((response: any) => {
        this.productDetails = response;
        // this.productDetails.cover = UtilitiesFunctions.imageUrlStringManager(
        //   "c_fill,h_500",
        //   this.productDetails.cover
        // );
        this.detailsLoading = false;
      })
      .catch((error: Error) => {
        this.detailsLoading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
      });
  }
}
